let floatingButtonExists = false;

const buyButtonFloating = () => {
  const buyButton = document.querySelector("button[data-add-to-cart]");
  const container = document.querySelector(".transition-body");

  if (!buyButton || floatingButtonExists || !container) return;

  const header = document.querySelector(".site-header");

  const headerHeight = header ? header.offsetHeight : 0;

  const floatingButton = buyButton.cloneNode(true);

  floatingButton.addEventListener("click", () => {
    buyButton.click();
  });

  floatingButton.classList.add("buy-button-floating");
  container.appendChild(floatingButton);

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting && entry.boundingClientRect.top < 48) {
          floatingButton.classList.add("show");
        } else {
          floatingButton.classList.remove("show");
        }
      });
    },
    {
      threshold: 0,
      rootMargin: `-${headerHeight}px 0px 0px 0px`,
    }
  );

  observer.observe(buyButton);

  floatingButtonExists = true;
};

const debounce = (func, delay) => {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), delay);
  };
};

const handleScreenSize = () => {
  if (!floatingButtonExists && window.innerWidth <= 768) {
    buyButtonFloating();
  } else if (floatingButtonExists && window.innerWidth > 768) {
    const floatingButton = document.querySelector(".buy-button-floating");

    floatingButton.remove();

    floatingButtonExists = false;
  }
};

document.addEventListener("DOMContentLoaded", () => {
  handleScreenSize();

  const form = document.querySelector("form[action='/cart/add']");

  if (!form) return;

  const observer = new MutationObserver(() => {
    if (floatingButtonExists) {
      const floatingButton = document.querySelector(".buy-button-floating");

      floatingButton.remove();

      floatingButtonExists = false;
    }

    handleScreenSize();
  });

  observer.observe(form, {
    childList: true,
    subtree: true,
  });
});

window.addEventListener("resize", debounce(handleScreenSize, 250));
